import { render, staticRenderFns } from "./UsernameSuggestions.vue?vue&type=template&id=46a6f69c&scoped=true"
import script from "./UsernameSuggestions.vue?vue&type=script&lang=js"
export * from "./UsernameSuggestions.vue?vue&type=script&lang=js"
import style0 from "./UsernameSuggestions.vue?vue&type=style&index=0&id=46a6f69c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a6f69c",
  null
  
)

export default component.exports